import Vue from 'vue'
import moment from 'moment'

// 日期和时间的格式化 1992/05/08 12:00:00  YYYY-MM-DD HH:mm:ss
Vue.filter('dateTimeFormat', function(value, formatValue) {
    if (!value || !formatValue) return value
    value = new Date(+value).getTime()
    if (value) return moment(value).format(formatValue)
    return
})